module.exports = __webpack_public_path__ + "img/green_012.9d22ea2b.png";